import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { PureComponent } from 'react';
import { styles as pdfStyles } from 'app/components/panels/inp/pdf/PdfDocument';
import MeasureUtils from 'app/common/util/MeasureUtils';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import { ATFCMDetail } from 'app/model/SOL49';
import { RegulationDto } from 'app/model/CORE';
import ConditionalRender from 'app/common/components/ConditionalRender';
import Utils from 'app/common/util/Utils';

export class ATFCMDetails extends PureComponent<{ atfcmDetails: { [fmp: string]: ATFCMDetail } }> {
    render() {
        return (
            <View>
                <Text style={pdfStyles.section_title}>ATFCM Details</Text>
                {Object.entries(this.props.atfcmDetails).map(([tvSet, { info, regulations, scenarios, hotspots }]) => {
                    return (
                        <View key={tvSet}>
                            <Text style={pdfStyles.h2}>{tvSet}</Text>
                            {Utils.isNotEmptyString(info) && <Text>{info}</Text>}
                            {regulations.length > 0 && (
                                <View>
                                    <Text style={pdfStyles.h3_underlined}>Regulations</Text>
                                    {regulations.map(regulation => (
                                        <View
                                            key={regulation.measureId.id}
                                            style={{ paddingBottom: '5px' }}
                                            wrap={false}>
                                            {this.renderRegulationHeader(regulation)}
                                            {this.renderRegulationInfo(regulation)}
                                        </View>
                                    ))}
                                </View>
                            )}
                            {scenarios.length > 0 && (
                                <View>
                                    <Text style={pdfStyles.h3_underlined}>Scenarios</Text>
                                    {scenarios.map(scenario => (
                                        <View
                                            key={scenario.scenarioReference.scenarioId}
                                            style={{ paddingBottom: '5px' }}
                                            wrap={false}>
                                            {this.renderRegulationHeader(scenario)}
                                            {this.renderRegulationInfo(scenario)}
                                        </View>
                                    ))}
                                </View>
                            )}
                            {hotspots.length > 0 && (
                                <View>
                                    <Text style={pdfStyles.h3_underlined}>Hotspots</Text>
                                    {hotspots.map((hotspot, i) => (
                                        <View
                                            key={`${hotspot.hotspotId.tvId}-${i}`}
                                            style={{ paddingBottom: '5px' }}
                                            wrap={false}>
                                            <Text style={styles.text}>
                                                <Text style={{ fontWeight: 'bold' }}>
                                                    {hotspot.hotspotId.tvId}{' '}
                                                    {TimePeriodUtils.formatHHMM(hotspot.hotspotId.timePeriod)}
                                                </Text>
                                                <Text>/ {hotspot.remark}</Text>
                                            </Text>
                                        </View>
                                    ))}
                                </View>
                            )}
                        </View>
                    );
                })}
            </View>
        );
    }

    private renderRegulationHeader(regulation: RegulationDto) {
        return (
            <Text style={styles.text}>
                <Text style={{ fontWeight: 'bold' }}>
                    {MeasureUtils.getTvLocation(regulation).id} {TimePeriodUtils.formatHHMM(regulation.applicability)}
                </Text>
                <Text> due to {regulation.reason}</Text>
            </Text>
        );
    }

    private renderRegulationInfo(regulation: RegulationDto) {
        return (
            <View style={styles.text}>
                <ConditionalRender
                    condition={Utils.isNotExists(regulation.scenarioReference) && Utils.isExists(regulation.remark)}>
                    <Text style={styles.text}>{regulation.remark}</Text>
                </ConditionalRender>
                <ConditionalRender
                    condition={
                        Utils.isExists(regulation.scenarioReference) && Utils.isExists(regulation.location?.description)
                    }>
                    {regulation.location?.description?.split('\n').map((t, i) => (
                        <Text key={i} style={styles.text}>
                            {t}
                        </Text>
                    ))}
                </ConditionalRender>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    text: {
        paddingLeft: '10px',
        lineHeight: 1.5,
    },
});
